module.exports = __webpack_public_path__ + "assets/img/search_label.b52c9d36.png";